import { create } from "zustand";

export const useUserDetailStore = create((set) => ({
  userDetail: null,
  userDetailLoaded: false,
  setUserDetail: (userDetail) =>
    set({ userDetail, userDetailLoaded: true }),
  resetUserDetail: () =>
    set({ userDetail: null, userDetailLoaded: false }),
}));
